import { Toggle } from 'framework7-react';
import { FC, useMemo } from 'react';

import { uniq } from 'lodash';

import { useEventQuery } from '@queries/EventQueries';
import { useSeries } from '@queries/TagQueries';

import { useUpdateEventMutation } from '@mutations/EventMutations';

import { TitleToolbar } from '@components/layout/TitleToolbar/TitleToolbar';

import { SuperAdminEventCategoryToggles } from '@screens/series/components/SuperAdminEventCategoryToggles';

const PRIMARY_SERIES_SLUGS = ['denver-drag', 'denver-queer-calendar'];

export const SuperAdminManagementFields: FC<{ eventId: string }> = ({ eventId }) => {
  const { isFetched: seriesIsReady, series = [] } = useSeries();
  const { event } = useEventQuery(eventId);
  const { updateEventAsync } = useUpdateEventMutation({ eventId });

  const primarySeries = useMemo(() => {
    return series.filter((series) => PRIMARY_SERIES_SLUGS.includes(series.slug));
  }, [series]);

  const handleUpdateSeries = async (tagId: string, toggleEvent: any) => {
    try {
      const isAdd = toggleEvent.target.checked;
      const { event: fetchedEvent } = await useEventQuery.fn(event._id);
      let tagIds = fetchedEvent.series?.map(({ _id }) => _id).filter(Boolean) ?? [];

      if (isAdd) {
        tagIds.push(tagId);
      } else {
        tagIds = tagIds.filter((id) => id !== tagId);
      }

      const updatedTagIds: string[] = uniq(tagIds);

      await updateEventAsync({
        tagIds: updatedTagIds,
      });
    } catch (e) {
      alert('Failed to update event in series');
    }
  };

  return (
    <>
      {primarySeries.length && event && (
        <>
          <div className="my-4 d-grid gap-2">
            {primarySeries.map((series) => (
              <div key={series._id} className="d-flex align-items-center justify-content-between">
                <strong>{series.title}</strong>
                <div>
                  <Toggle
                    defaultChecked={event.series?.map(({ _id }) => _id)?.includes(series._id)}
                    onChange={(event) => handleUpdateSeries(series._id, event)}
                  />
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      <SuperAdminEventCategoryToggles eventId={eventId} />
    </>
  );
};
